<script setup>
defineProps(['firstText', 'lastText'])

const { locale } = useI18n()
const story = await useAsyncStoryblok('components/content/privacy-policy', { version: 'publish', language: locale.value })
</script>

<template>
  <label for="terms" class="ml-2 text-sm text-primary">
    {{ firstText }}
    <a target="_blank" :href="story.content.url.url ? story.content.url.url : ''" class="text-red-600 font-semibold hover:underline">{{ lastText }}</a></label>
</template>
